import { dictIdDelivery, dictIdDeliveryFormatted } from '../../consts';

export const STYLE_COLLECTIONS = [
  { key: 'MAIN', label: 'Ready to wear' },
  { key: 'SWIMWEAR', label: 'Swimwear' },
  { key: 'FOOTWEAR', label: 'Shoes' },
];

const PREFERRED_CAPSULA_ORDER = [
  'MAIN COLLECTION',
  'SWIMWEAR',
  'MENSWEAR',
  'SKI',
];

export const timeout = delay => new Promise(res => setTimeout(res, delay));

export const decorateWithFormattedDelivery = product => ({
  ...product,
  formatted_delivery: dictIdDeliveryFormatted[product.delivery_id],
});

const inDelivery = (product, deliveryNumber) =>
  product.delivery_id === dictIdDelivery[deliveryNumber];

export const groupProductsForPDF = products => {
  const groups = {
    d1: [],
    d2: [],
    d3: [],
    d4: [],
    c2: [],
    shoes1: [],
    shoes2: [],
    shoes3: [],
    swim2: [],
    swim3: [],
    men2: [],
  };
  products.forEach(product => {
    if (inDelivery(product, 1)) {
      if (product.style_collection === 'MAIN') groups.d1.push(product);
      else if (product.capsula === 'FOOTWEAR') groups.shoes1.push(product);
    } else if (inDelivery(product, 2)) {
      if (product.style_collection === 'MAIN') groups.d2.push(product);
      else if (product.capsula === 'FOOTWEAR') groups.shoes2.push(product);
      else if (product.capsula === 'SWIMWEAR') groups.swim2.push(product);
      else if (product.capsula === 'MENSWEAR') groups.men2.push(product);
      else groups.c2.push(product);
    } else if (inDelivery(product, 3)) {
      if (product.style_collection === 'MAIN') groups.d3.push(product);
      else if (product.capsula === 'FOOTWEAR') groups.shoes3.push(product);
      else if (product.capsula === 'SWIMWEAR') groups.swim3.push(product);
    } else if (inDelivery(product, 4)) {
      groups.d4.push(product);
    }
  });
  return groups;
};

export const productsForDeliveryAndCollection = (
  allProducts,
  deliveryNumber,
  styleCollection
) =>
  allProducts.filter(
    product =>
      product.delivery_id === dictIdDelivery[deliveryNumber] &&
      product.style_collection === styleCollection
  );

export const groupByCapsula = products => {
  const seen = new Set();
  products.forEach(product => {
    if (product.capsula) seen.add(product.capsula);
  });

  const orderedKeys = [
    ...PREFERRED_CAPSULA_ORDER.filter(key => seen.has(key)),
    ...Array.from(seen)
      .filter(key => !PREFERRED_CAPSULA_ORDER.includes(key))
      .sort(),
  ];

  return orderedKeys.map(capsula => ({
    capsula,
    products: products.filter(product => product.capsula === capsula),
  }));
};

export const getAdjacentProduct = (products, current, direction) => {
  if (!products?.length || !current) return current;
  const index = products.findIndex(
    product => product.style_code === current.style_code
  );
  if (index === -1) return products[0];
  if (direction === 'next') {
    return index >= products.length - 1 ? products[0] : products[index + 1];
  }
  return index === 0 ? products[products.length - 1] : products[index - 1];
};
